import {
    UNIT_REBUILD_INFO_REQUEST,
    UNIT_REBUILD_INFO_SUCCESS,
    UNIT_REBUILD_INFO_ERROR,
} from 'state/actions/unit_rebuild_info'

const initialState = {
    loading: false,
    loaded: false,
    errorMessage: '',
    sorties: {},
    fort_battles: {},
    unit_info: {},
    expiresAt: null,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case UNIT_REBUILD_INFO_REQUEST: {
        return {
            ...state,
            loading: true,
            loaded: false,
            errorMessage: '',
        }
    }
    case UNIT_REBUILD_INFO_ERROR: {
        return {
            ...state,
            loading: false,
            loaded: false,
            errorMessage: action.payload.errorMessage,
        }
    }
    case UNIT_REBUILD_INFO_SUCCESS: {
        return {
            ...state,
            loading: false,
            loaded: true,
            sorties: action.payload.sorties,
            fort_battles: action.payload.fort_battles,
            unit_info: action.payload.unit_info,
            expiresAt: action.payload.expiresAt,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/units/unit_rebuild_info.js